import { COLORS } from "../../../../constants/shared/shared.constants";

export const paginatorCellStyle = {
  borderBottomWidth: 0,
};

export const pageNumberInputSx = {
  "& input[type=number]": {
    MozAppearance: "textfield",
  },
  "& input[type=number]::-webkit-outer-spin-button, & input[type=number]::-webkit-inner-spin-button":
    {
      WebkitAppearance: "none",
      margin: 0,
    },
  "& .MuiOutlinedInput-input": {
    textAlign: "center",
    borderColor: COLORS.DARK_NAVY,
    px: 0.5,
  },
  width: "2.9rem",
  height: "2.5rem",
  justifyContent: "center",
};

export const paginationSx = {
  "& .MuiPaginationItem-root": {
    color: `${COLORS.DARK_NAVY} !important`,
    cursor: "pointer",
    backgroundColor: `${COLORS.WHITE} !important`,
    boxShadow: "none !important",
    border: `0.8px solid ${COLORS.BLACK_SHADOW} !important`,
  },
  "& .MuiPaginationItem-root.Mui-selected": {
    backgroundColor: `${COLORS.DARK_NAVY} !important`,
    color: `${COLORS.WHITE} !important`,
    boxShadow: "none !important",
  },
};
